import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const Name = localStorage.getItem('name');
  const userType = localStorage.getItem('user_type');
  const currentLocation = useLocation();

  // User type 4 is Dealer-only
  const isDealerOnly = userType === '4';

  return (
    <aside className="main-sidebar sidebar-dark-maroon elevation-4">

      {/* ==========================================
          BRAND LOGO
      =========================================== */}
      <Link
        to={isDealerOnly ? '/dealer' : '/dashboard'}
        className="brand-link"
      >

        <img
          src="/dist/img/v4surelogo.png"
          alt="Shivam Moto Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: '.8' }}
        />

        <span className="brand-text font-weight-light">
          Shivam Moto
        </span>

      </Link>


      {/* ==========================================
          SIDEBAR
      =========================================== */}
      <div className="sidebar">


        {/* ==========================================
            USER PANEL
        =========================================== */}
        <div className="user-panel mt-3 d-flex">

          <div className="image">

            <img
              src="/dist/img/userpic.png"
              className="img-circle elevation-2"
              alt="User"
            />

          </div>


          <div className="info">

            <p
              style={{ color: '#c2c7d0' }}
              className="d-block"
            >
              {Name || 'user'}
            </p>

          </div>

        </div>


        {/* ==========================================
            SIDEBAR MENU
        =========================================== */}
        <nav className="mt-2">

          <ul
            className="nav nav-pills nav-sidebar flex-column"
            role="menu"
            data-widget="treeview"
            data-accordion="false"
          >


            {/* =====================================================
                USER TYPE 4
                DEALER ONLY
            ====================================================== */}

            {isDealerOnly ? (

              <li className="nav-item">

                <Link
                  to="/dealer"
                  className={`nav-link ${
                    currentLocation.pathname === '/dealer'
                      ? 'active'
                      : ''
                  }`}
                >

                  <i className="nav-icon far fa-user"></i>

                  <p>
                    Dealer
                  </p>

                </Link>

              </li>


            ) : (


              /* =====================================================
                 ALL OTHER USER TYPES
              ====================================================== */

              <>


                {/* ==========================================
                    SUPER DEALER
                    User Type 1 and 2
                =========================================== */}

                {(userType === '1' || userType === '2') && (

                  <li className="nav-item">

                    <Link
                      to="/super-dealer"
                      className={`nav-link ${
                        currentLocation.pathname === '/super-dealer'
                          ? 'active'
                          : ''
                      }`}
                    >

                      <i className="nav-icon far fa-user"></i>

                      <p>
                        Super Dealer
                      </p>

                    </Link>

                  </li>

                )}


                {/* ==========================================
                    BULK UPLOAD
                    User Type 1 ONLY
                =========================================== */}

                {userType === '1' && (

                  <li className="nav-item">

                    <Link
                      to="/bulk-upload"
                      className={`nav-link ${
                        currentLocation.pathname === '/bulk-upload'
                          ? 'active'
                          : ''
                      }`}
                    >

                      <i className="nav-icon fas fa-tachometer-alt"></i>

                      <p>
                        Bulk Upload
                      </p>

                    </Link>

                  </li>

                )}


                {/* ==========================================
                    DASHBOARD
                    All users except Type 4
                =========================================== */}

                <li className="nav-item">

                  <Link
                    to="/dashboard"
                    className={`nav-link ${
                      currentLocation.pathname === '/dashboard'
                        ? 'active'
                        : ''
                    }`}
                  >

                    <i className="nav-icon fas fa-tachometer-alt"></i>

                    <p>
                      Dashboard
                    </p>

                  </Link>

                </li>


                {/* ==========================================
                    BUYER
                    All users except Type 4
                =========================================== */}

                <li className="nav-item">

                  <Link
                    to="/buyer"
                    className={`nav-link ${
                      currentLocation.pathname === '/buyer'
                        ? 'active'
                        : ''
                    }`}
                  >

                    <i className="nav-icon fa fa-users"></i>

                    <p>
                      Buyer
                    </p>

                  </Link>

                </li>


                {/* ==========================================
                    DEALER
                    All users except Type 4
                =========================================== */}

                <li className="nav-item">

                  <Link
                    to="/dealer"
                    className={`nav-link ${
                      currentLocation.pathname === '/dealer'
                        ? 'active'
                        : ''
                    }`}
                  >

                    <i className="nav-icon far fa-user"></i>

                    <p>
                      Dealer
                    </p>

                  </Link>

                </li>


                {/* ==========================================
                    CANCEL BILL
                    All users except Type 4
                =========================================== */}

                <li className="nav-item">

                  <Link
                    to="/cancelbill"
                    className={`nav-link ${
                      currentLocation.pathname === '/cancelbill'
                        ? 'active'
                        : ''
                    }`}
                  >

                    <i className="nav-icon fa fa-window-close"></i>

                    <p>
                      Cancel Bill
                    </p>

                  </Link>

                </li>


                {/* ==========================================
                    SEARCH BILL
                    All users except Type 4
                =========================================== */}

                <li className="nav-item">

                  <Link
                    to="/search-bill"
                    className={`nav-link ${
                      currentLocation.pathname === '/search-bill'
                        ? 'active'
                        : ''
                    }`}
                  >

                    <i className="nav-icon fa fa-search"></i>

                    <p>
                      Search Bill
                    </p>

                  </Link>

                </li>


                {/* ==========================================
                    BILLING
                    All users except Type 4
                =========================================== */}

                <li className="nav-item">

                  <Link
                    to="/billing"
                    className={`nav-link ${
                      currentLocation.pathname === '/billing'
                        ? 'active'
                        : ''
                      }`}
                  >

                    <i className="nav-icon fas fa-book"></i>

                    <p>
                      Billing
                    </p>

                  </Link>

                </li>


              </>

            )}

          </ul>

        </nav>

      </div>

    </aside>
  );
};

export default Sidebar;